import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/Craftsmanship/craftsmanship.js");
